import type { LiveTradeResponse } from 'apiConnector/secondary-market/live/models';
import type { TradeState } from 'state/secondaryMarket/shared/trade/trade.model';
import type { Collection } from 'state/utils/types';

export type LiveTradeState = TradeState<LiveTradeResponse>;

export type LiveTradeMap = Collection<LiveTradeState>;

export const initialLiveTradeMap = (): LiveTradeMap => ({});
